import { gql } from '@apollo/client';

import {
  BUCKET_FRAGMENT,
  USER_FILE_METADATA_FRAGMENT,
  USER_FILES_FRAGMENT
} from '@src/api/operations/fragments/fragments.gql';

// eslint-disable-next-line import/prefer-default-export
export const USER_FILES = gql`
  ${USER_FILES_FRAGMENT}
  ${USER_FILE_METADATA_FRAGMENT}
  ${BUCKET_FRAGMENT}
  query ExploreDirectoryFiles($recursive: Boolean!, $folder: String) {
    exploreDirectoryFiles(recursive: $recursive, folder: $folder) {
      __typename
      paths {
        __typename
        ...FileBucketFragment
        files {
          ...FileCoreFragment
          metadata {
            ...FileMetaDataFragment
          }
        }
      }
      message
      status
      errors {
        code
        path
        message
      }
    }
  }
`;
